import { NotificationService } from '../../shared/notification/notification.service';
import { TaskService } from '../shared/task.service';
import { TaskDto } from 'src/app/tasks/shared/dto/task.dto';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'wl-task-edit-dialog',
  templateUrl: './task-edit-dialog.component.html',
  styleUrls: ['./task-edit-dialog.component.less'],
    standalone: false
})
export class TaskEditDialogComponent implements OnInit {
  @Input()
  get show() {
    return this._show;
  }
  set show(value: boolean) {
    this._show = value;
    if (!value) {
      this.task = null;
      this.creatingUnlinkedTask = false;
    }
    this.showChange.emit(this._show);
  }
  @Output() showChange: EventEmitter<boolean> = new EventEmitter();
  @Output() taskSaved: EventEmitter<TaskDto> = new EventEmitter();

  task: TaskDto;
  creatingUnlinkedTask = false;
  loadingTask = false;
  isSaving = false;

  private _show: boolean;
  get showCrud() {
    return this.task?.TaskId || this.task?.ProfileID || this.loadingTask || this.creatingUnlinkedTask;
  }

  constructor(private _taskService: TaskService, private _notificationService: NotificationService) {}

  ngOnInit(): void {}

  initWithProfile(profileId: number) {
    this.task = {
      ProfileID: profileId,
    } as TaskDto;
  }

  createUnlinkedTask() {
    this.creatingUnlinkedTask = true;
    this.task = {} as TaskDto;
  }

  open(taskId?: number) {
    this.show = true;
    if (taskId) {
      this.loadingTask = true;
      this._taskService
        .get(taskId)
        .then(
          (task) => {
            this.task = task;
          },
          (error) => {
            this._notificationService.httpError(error);
          }
        )
        .finally(() => (this.loadingTask = false));
    }
  }

  save() {
    this.isSaving = true;
    let crudPromise;
    if (this.task.TaskId) {
      crudPromise = this._taskService.update(this.task);
    } else {
      crudPromise = this._taskService.create(this.task);
    }
    crudPromise
      .then(
        () => {
          this.taskSaved.emit(this.task);
          this._notificationService.translateSuccess('tasks.edit.saved-successfully');
          this.show = false;
        },
        (error) => {
          this._notificationService.httpError(error);
        }
      )
      .finally(() => (this.isSaving = false));
  }
}
